export default __webpack_public_path__ + "static/media/services.1f1c7f9b.png";